import CalendarTodayIcon from '@material-ui/icons/CalendarToday'

const CalendarIcon = (props) => <CalendarTodayIcon {...props} fontSize='small' />

export default CalendarIcon
